<template>
  <div class="complete-wrapper">
    <img class="w-full" src="../../assets/ScanBody/complete.svg" />
  </div>
</template>

<script>
export default {
  name: 'ScanComplete',
};
</script>

<style lang="scss" scoped>
.complete-wrapper {
  @apply absolute flex justify-center items-center;
  @screen sm {
    width: 200px;
  }
}
</style>
